import { useEffect, useState } from "react";
import axios from "axios";
import { ContenedorAnuncios } from "./ContenedorAnuncios";
import ContenedorProgreso from "./ContenedorProgreso";
import { useData } from "../Pages/DataContext";
import { getAllLinks } from "../Pages/constants";
import {
  formatearFechaReunion,
  formatearHoraReunion,
  normalizarLinksZoom,
  obtenerProximaReunionCurso,
} from "./zoomCourseUtils";
import "./ContenidoTablon.css";

export const ContenidoTablon = () => {
  const { dataClase } = useData();
  const [proximaReunion, setProximaReunion] = useState(null);
  const [cargandoZoom, setCargandoZoom] = useState(true);
  const [errorZoom, setErrorZoom] = useState(false);

  useEffect(() => {
    let activo = true;

    const cargarProximaReunion = async () => {
      if (!dataClase?.matricula_clase) {
        setProximaReunion(null);
        setCargandoZoom(false);
        return;
      }

      setCargandoZoom(true);
      setErrorZoom(false);

      try {
        const response = await axios.get(getAllLinks);
        if (!activo) return;

        const links = normalizarLinksZoom(response.data);
        setProximaReunion(
          obtenerProximaReunionCurso(links, dataClase.matricula_clase),
        );
      } catch (error) {
        console.error("Error al obtener la próxima reunión de Zoom:", error);
        if (!activo) return;

        setProximaReunion(null);
        setErrorZoom(true);
      } finally {
        if (activo) setCargandoZoom(false);
      }
    };

    cargarProximaReunion();

    return () => {
      activo = false;
    };
  }, [dataClase?.matricula_clase]);

  const textoEstadoZoom = () => {
    if (cargandoZoom) return "Consultando la próxima sesión...";
    if (errorZoom) return "No fue posible consultar las sesiones de Zoom.";
    if (!proximaReunion) return "No hay una próxima sesión programada para esta materia.";

    return `Próxima sesión: ${formatearFechaReunion(proximaReunion.fechaHora)} · ${formatearHoraReunion(proximaReunion.fechaHora)}`;
  };

  return (
    <main className="discussion-page">
      <section className="discussion-hero">
        <div>
          <span className="discussion-eyebrow">Comunidad del curso</span>
          <h1>Foro de discusión</h1>
          <p>Comparte ideas, plantea preguntas y participa en las conversaciones de tu clase.</p>
        </div>
        <div className="discussion-hero-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M4 5.5h16v10H9l-5 4v-14Z"/><path d="M8 9h8M8 12h5"/></svg>
        </div>
      </section>

      <div className="discussion-layout">
        <section className="discussion-main" aria-label="Publicaciones del foro">
          <ContenedorAnuncios />
        </section>

        <aside className="discussion-aside">
          <section className="discussion-side-card">
            <span className="discussion-side-label">Tu avance</span>
            <ContenedorProgreso />
          </section>
          <section className="discussion-side-card discussion-zoom-card">
            <span className="discussion-side-label">Sesiones en vivo</span>
            <h2>Ligas de Zoom</h2>
            <p className={`discussion-zoom-status${proximaReunion ? " discussion-zoom-status-available" : ""}`}>
              {textoEstadoZoom()}
            </p>

            {proximaReunion ? (
              <a
                className="discussion-zoom-button"
                href={proximaReunion.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Entrar a Zoom
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>
              </a>
            ) : (
              <button
                type="button"
                className="discussion-zoom-button"
                disabled
              >
                {cargandoZoom ? "Consultando Zoom..." : "Sin reunión programada"}
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>
              </button>
            )}
          </section>
        </aside>
      </div>
    </main>
  );
};
